/**
 * Specify the data retention interval type
 * @readonly
 * @enum {String}
 */
export const DATA_RETENTION_INTERVAL = {
  DAYS: 'days',
  YEARS: 'years',
};

/**
 * Specify the types of collections that always keep data regardless of
 * data retention policies
 * @readonly
 * @enum {String}
 */
export const DATA_RETENTION_KEEP = {
  TEAM: 'team',
  PUBLISHED: 'published',
};
